module.exports = __webpack_public_path__ + "static/media/intro.fa78ec10.mp3";